import BasicStyles from './BasicDetails.module.scss';
import Styles from './EducationDetails.module.scss';
import TextField from '@mui/material/TextField';
import Slide from '@mui/material/Slide';

export function EducationDetails({ profileData, handleInputChange, validation, setProfileData, setValidation, props }) {

    const masters = {
        masters_name: null,
        masters_university: null,
        masters_start_year: null,
        masters_end_year: null,
        masters_percentage: null,
    }

    const handleAddPG = () => {
        setProfileData({
            ...profileData,
            masters: { ...masters },
        });
        setValidation({
            ...validation,
            masters: { ...Object.fromEntries(Object.entries(masters).map(([key]) => [key, true])) }
        });
    }

    const handleDelPG = () => {
        setProfileData(prevProfileData => {
            const { masters, ...rest } = prevProfileData;
            return { ...rest };
        });
        setValidation(prevValidation => {
            const { masters, ...rest } = prevValidation;
            return { ...rest };
        });
    }

    const handleMsterInputChanges = (inputValue, fieldName, index) => {
        let isValid = true;
        const currentYear = new Date().getFullYear()
        switch (fieldName) {
            case 'masters_start_year':
                if (parseInt(inputValue) <= 1970 || parseInt(inputValue) > currentYear + 2) {
                    isValid = false;
                    break;
                }
                isValid = /^\d{4}$/.test(parseInt(inputValue));
                break;
            case 'masters_end_year':
                if (parseInt(inputValue) <= 1970 || parseInt(inputValue) > currentYear + 2) {
                    isValid = false;
                    break;
                }
                isValid = isValid = (/^\d{4}$/.test(parseInt(inputValue)) || inputValue.toLowerCase() === 'ongoing');;
                break;
            case 'masters_percentage':
                isValid = /^\d{1,2}(\.\d{1,2})?$/.test(parseFloat(inputValue));
                break;

            default:
                isValid = inputValue.trim() !== '';
                break;
        }


        setProfileData(prevData => ({
            ...prevData,
            masters: {
                ...prevData.masters,
                [fieldName]: inputValue
            }
        }));
        setValidation(validation => ({
            ...validation,
            masters: {
                ...validation.masters,
                [fieldName]: isValid
            }
        }));
    };

    return (
        <>
            <Slide direction="left" in mountOnEnter unmountOnExit>
                <div id='eduFormContainer'
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div id='EduForm' className={BasicStyles.nameForm}>
                        <p
                            id='subHeading'
                            className={`${BasicStyles.subHeading}`}
                        >
                            Education
                        </p>
                        <div
                            id='educationBoxes'
                            className={`${BasicStyles.nameTextboxes} ${Styles.educationForm}`}
                        >
                            {profileData?.masters?.masters_name !== undefined &&
                                <>
                                    <p id='pgheading' className={`${BasicStyles.subHeading} ${Styles.sectionHeading}`}>
                                        Post-Graduation
                                    </p>
                                    <div id='pgInputs' className={Styles.pgInputs}>
                                        <TextField
                                            error={!validation?.masters?.masters_name}
                                            id="masters-name"
                                            label="Masters Name"
                                            placeholder="Masters Name"
                                            fullWidth={false}
                                            helperText={!validation?.masters?.masters_name ? 'Enter Your Masters Name' : ' '}
                                            InputLabelProps={{
                                                maxLength: 50,
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                maxLength: 50
                                            }}
                                            value={profileData?.masters?.masters_name || ''}
                                            onChange={(e) => handleMsterInputChanges(e.target.value, 'masters_name')}
                                        />

                                        <TextField
                                            error={!validation?.masters?.masters_university}
                                            id="masters-university"
                                            label="Master's University, Location"
                                            placeholder="Master's University, Location"
                                            fullWidth={false}
                                            helperText={!validation?.masters?.masters_university ? 'Enter Your Masters University' : ' '}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                maxLength: 50
                                            }}
                                            value={profileData?.masters?.masters_university || ''}
                                            onChange={(e) => handleMsterInputChanges(e.target.value, 'masters_university')}
                                        />
                                        <TextField
                                            error={!validation?.masters?.masters_start_year}
                                            id="masters-start-year"
                                            label="Start of Degree"
                                            placeholder="YYYY"
                                            fullWidth={false}
                                            helperText={!validation?.masters?.masters_start_year ? 'Enter Your Masters Year' : ' '}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                maxLength: 4
                                            }}
                                            value={profileData?.masters?.masters_start_year || ''}
                                            onChange={(e) => handleMsterInputChanges(e.target.value, 'masters_start_year')}
                                        />
                                        <TextField
                                            error={!validation?.masters?.masters_end_year}
                                            id="masters-end-year"
                                            label="Year of Post-Graduation"
                                            placeholder="YYYY / Ongoing"
                                            fullWidth={false}
                                            helperText={!validation?.masters?.masters_end_year ? 'Enter Your Masters Year' : ' '}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                maxLength: 7
                                            }}
                                            value={profileData?.masters?.masters_end_year || ''}
                                            onChange={(e) => handleMsterInputChanges(e.target.value, 'masters_end_year')}
                                        />
                                        <TextField
                                            error={!validation?.masters?.masters_percentage}
                                            id="masters-percentage"
                                            label="Percentage"
                                            placeholder="81"
                                            fullWidth={false}
                                            helperText={!validation?.masters?.masters_percentage ? 'Enter Your Masters Percentage' : ' '}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                maxLength: 2,
                                            }}
                                            value={profileData?.masters?.masters_percentage || ''}
                                            onChange={(e) => handleMsterInputChanges(e.target.value, 'masters_percentage')}
                                        />
                                    </div>
                                </>}
                            <p id='gradHeading' className={`${BasicStyles.subHeading} ${Styles.sectionHeading}`}>
                                Graduation
                            </p>
                            <div id='degreeInputs' className={Styles.degreeInputs}>
                                <TextField
                                    error={!validation.degree_name}
                                    id="degree-name"
                                    label="Degree Name"
                                    placeholder="Degree Name"
                                    fullWidth={false}
                                    helperText={!validation.degree_name ? 'Enter Your Degree Name' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 50
                                    }}
                                    value={profileData.degree_name || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'degree_name')}
                                />
                                <TextField
                                    error={!validation.degree_university}
                                    id="degree-university"
                                    label="University/College"
                                    placeholder="Degree University, Location"
                                    fullWidth={false}
                                    helperText={!validation.degree_university ? 'Enter Your Degree University' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 50
                                    }}
                                    value={profileData.degree_university || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'degree_university')}
                                />
                                <TextField
                                    error={!validation.degree_start_year}
                                    id="degree-start-year"
                                    label="Start of Degree"
                                    placeholder="YYYY"
                                    fullWidth={false}
                                    helperText={!validation.degree_start_year ? 'Enter Your Degree Year' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 4
                                    }}
                                    value={profileData.degree_start_year || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'degree_start_year')}
                                />
                                <TextField
                                    error={!validation.degree_end_year}
                                    id="degree-start-end-year"
                                    label="Year of Graduation"
                                    placeholder="YYYY / Ongoing"
                                    fullWidth={false}
                                    helperText={!validation.degree_end_year ? 'Enter Your Degree Year' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 7
                                    }}
                                    value={profileData.degree_end_year || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'degree_end_year')}
                                />
                                <TextField
                                    error={!validation.degree_percentage}
                                    id="degree-percentage"
                                    label="Percentage"
                                    placeholder="75"
                                    fullWidth={false}
                                    helperText={!validation.degree_percentage ? 'Enter Your Degree Percentage' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 5
                                    }}
                                    value={profileData.degree_percentage || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'degree_percentage')}
                                />
                            </div>
                            <p id='hsHeading' className={`${BasicStyles.subHeading} ${Styles.sectionHeading}`}>
                                High School - 12th
                            </p>
                            <div id='highSchoolInputs' className={Styles.highSchoolInputs}>
                                <TextField
                                    error={!validation.high_school_board}
                                    id="high-school-board"
                                    label="High School Board"
                                    placeholder="High School Board"
                                    fullWidth={false}
                                    helperText={!validation.high_school_board ? 'Enter Your High School Board' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 50
                                    }}
                                    value={profileData.high_school_board || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'high_school_board')}
                                />
                                <TextField
                                    error={!validation.high_school_name}
                                    id="high-school-name"
                                    label="High School Name, Location"
                                    placeholder="High School Name, Location"
                                    fullWidth={false}
                                    helperText={!validation.high_school_name ? 'Enter Your High School Name' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 50
                                    }}
                                    value={profileData.high_school_name || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'high_school_name')}
                                />
                                <TextField
                                    error={!validation.high_school_start_year}
                                    id="high-school-start-year"
                                    label="High School Start Year"
                                    placeholder="YYYY"
                                    fullWidth={false}
                                    helperText={!validation.high_school_start_year ? 'Enter Your High School Year' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 4
                                    }}
                                    value={profileData.high_school_start_year || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'high_school_start_year')}
                                />
                                <TextField
                                    error={!validation.high_school_end_year}
                                    id="high-school-end-year"
                                    label="High School End Year"
                                    placeholder="YYYY"
                                    fullWidth={false}
                                    helperText={!validation.high_school_end_year ? 'Enter Your High School Year' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 4
                                    }}
                                    value={profileData.high_school_end_year || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'high_school_end_year')}
                                />
                                <TextField
                                    error={!validation.high_school_percentage}
                                    id="high-school-percentage"
                                    label="Percentage"
                                    placeholder="81"
                                    fullWidth={false}
                                    helperText={!validation.high_school_percentage ? 'Enter Your High School Percentage' : ' '}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        maxLength: 5
                                    }}
                                    value={profileData.high_school_percentage || ''}
                                    onChange={(e) => handleInputChange(e.target.value, 'high_school_percentage')}
                                />
                            </div>
                        </div>
                    </div>
                    <div id='eduBtnContainer' className={Styles.eduBtnContainer}>
                        <button
                            onClick={validation?.masters?.masters_name ? handleDelPG : handleAddPG}
                            id='addPGBtn' className={Styles.addPGBtn}
                            // disabled={validation?.masters?.masters_name}
                        >
                            {validation?.masters?.masters_name ? 'Remove Postgraduate Data' : 'Add Postgraduate Data'}
                        </button>
                    </div>
                </div>
            </Slide >
        </>

    )
}